const GridSkeleton = () => {
  return (
    <div className="pt-[15px] pb-[15px] flex flex-col  page-loading">
      <div className="grow w-full  h-[20px] rounded bg-primary-skeleton mb-[10px] "></div>
      <div className="grow w-full  h-[20px] rounded  bg-primary-skeleton mb-[10px] "></div>
      <div className="grow w-full h-[20px] rounded bg-primary-skeleton mb-[10px] "></div>

      <div className="mt-[20px] grow w-[10%] h-[20px] rounded  bg-primary-skeleton mb-[10px] "></div>
      <div className="grow w-[25%] h-[20px] rounded  bg-primary-skeleton mb-[10px] "></div>
      <div className="grow w-[25%] h-[20px] rounded  bg-primary-skeleton mb-[10px] "></div>
      <div className="grow w-[10%] h-[20px] rounded bg-primary-skeleton mb-[10px] "></div>
      <div className="grow w-[25%] h-[20px] rounded  bg-primary-skeleton mb-[10px] "></div>

      <div className="grid grid-cols-2 gap-[10px] mt-[20px]">
        <div className="rounded w-full h-[25px]  bg-primary-skeleton "></div>
        <div className="rounded w-full h-[25px] bg-primary-skeleton "></div>
        <div className="rounded w-full h-[25px]  bg-primary-skeleton"></div>
        <div className="rounded w-full h-[25px]  bg-primary-skeleton"></div>
      </div>
    </div>
  )
}

export default GridSkeleton
